import {
    Grid,
    Card,
    Box,
    Stack,
    // LinearProgress,
    Chip,
    // Divider,
    InputBase,
    Paper,
  } from "@mui/material";
  import Icon from "@mui/material/Icon";
  import MDBox from "components/MDBox";
  import MDTypography from "components/MDTypography";
  import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
  import DashboardNavbar from "examples/Navbars/DashboardNavbar";
  import Footer from "examples/Footer";
  import { useSelector } from "react-redux";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getPlaces } from "store/slice/places/placeSlice";
import { getOccupancy } from "store/slice/reports/reportSlice";
import MDProgress from "components/MDProgress";
import { useState } from "react";

  export default function Occupancy() {
    const [search, setSearch] = useState("");
    const [loading, setLoading] = useState(true);
    const dispatch = useDispatch();
   
    useEffect(() => {
      getMyPlaces();
    }, []);
    const placeList = useSelector((state) => state.places?.placesList || []);
    const getMyPlaces = async () => {
      
      if(placeList.length > 0){
        const p = placeList.map((place) => place._id);
        await dispatch(getOccupancy(p));
        setLoading(false);
        return;
      }
      const { places } = await dispatch(getPlaces()).unwrap();
      // console.log("places in occupancy >>> ", places);
      const p = places.map((place) => place._id);
      await dispatch(getOccupancy(p));
      setLoading(false);
    }
      // const placeList = useSelector((state) => state.places?.placesList || []);
      
  
    const occupancy = useSelector((state) => state.report?.occupancy || {});
    const { totalCapacity, reserved, available, averageOccupancy, data, narrativeText } = occupancy;


function getTop5BusyLocations(locations) {
    // 1. Calculate Occupancy Percentage and attach it to the object
    // We map to a new array to avoid mutating the original data if necessary
    const processedLocations = locations.map(location => {
        let occupancyRate = 0;
        
        if (location.totalSpaces > 0) {
            const occupied = location.totalSpaces - location.freeSpaces;
            occupancyRate = (occupied / location.totalSpaces) * 100;
        }

        return {
            ...location,
            occupancyRate: parseFloat(occupancyRate.toFixed(1)) // Keeping 1 decimal place
        };
    });
    // 2. Sort by Occupancy Rate (Descending)
    processedLocations.sort((a, b) => b.occupancyRate - a.occupancyRate);
    // 3. Return top 5
    return processedLocations.slice(0, 5);
}

  const top5 = (data && data?.length > 0 && getTop5BusyLocations(data)) || [];

    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox px={3} py={2} bgcolor="#f8f9fa" minHeight="100vh">
          <Grid container spacing={3}>
            
            {/* ===== Predictive Intelligence Banner ===== */}
            <Grid item xs={12}>
              <Card
                sx={{
                  background: "linear-gradient(135deg, #4338ca 0%, #2563eb 100%)",
                  color: "#fff",
                  borderRadius: 4,
                  p: 4,
                  position: "relative",
                }}
              >
                <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
                  <Stack spacing={2} sx={{ maxWidth: "80%" }}>
                    <Stack direction="row" spacing={1} alignItems="center">
                      <Icon sx={{ fontSize: "20px !important" }}>lightbulb</Icon>
                      <MDTypography variant="button" fontWeight="bold" color="white" textTransform="uppercase" letterSpacing={1}>
                         {loading ? "Analyzing..." : "Predictive Intelligence"}
                      </MDTypography>
                    </Stack>
  
                    <MDTypography variant="caption" color="white" fontWeight="bold" lineHeight={1.4}>
                    {narrativeText}
                    </MDTypography>
  
                    {/* <MDTypography variant="body2" color="white" opacity={0.8}>
                      Direct all incoming traffic to the East Side Lot to maximize availability. Secondary options include Central Park and North Plaza, which both maintain 50% capacity.
                    </MDTypography> */}
                  </Stack>
  
                  {/* Market Trend Badge */}
                  <Paper sx={{ p: 1.5, textAlign: "center", borderRadius: 3, bgcolor: "rgba(255,255,255,0.15)", backdropFilter: "blur(4px)", color: "white", minWidth: 100 }}>
                      <MDTypography variant="caption" fontWeight="bold" color="white" display="block">MARKET TREND</MDTypography>
                      <Stack direction="row" alignItems="center" justifyContent="center" spacing={0.5}>
                          <Icon fontSize="small">bar_chart</Icon>
                          <MDTypography variant="button" fontWeight="bold" color="white">Stable</MDTypography>
                      </Stack>
                  </Paper>
                </Stack>
              </Card>
            </Grid>
  
            {/* ===== KPI STRIP ===== */}
            {[
              ["Total Capacity", totalCapacity, "apartment"],
              ["Reserved", reserved, "lock"],
              ["Available", available, "check_circle_outline"],
              ["Avg. Occupancy", averageOccupancy, "trending_up"],
            ].map(([label, value, icon], i) => (
              <Grid item xs={12} md={3} key={i}>
                <Card sx={{ p: 3, borderRadius: 3, boxShadow: "0 4px 20px 0 rgba(0,0,0,0.05)" }}>
                  <Stack direction="row" spacing={2} alignItems="center">
                    <Box sx={{ p: 1.5, borderRadius: 2, bgcolor: "#f0f4ff" }}>
                      <Icon color="info">{icon}</Icon>
                    </Box>
                    <Box>
                      <MDTypography variant="caption" fontWeight="bold" color="text" textTransform="uppercase">
                        {label}
                      </MDTypography>
                      <MDTypography variant="h4" fontWeight="bold">
                        {value}
                      </MDTypography>
                    </Box>
                  </Stack>
                </Card>
              </Grid>
            ))}
  
            {/* ===== LEFT: LIVE MATRIX ===== */}
            <Grid item xs={12} md={8} sx={{ order: { xs: 2, md: 1 } }}>
              <Stack direction="row" justifyContent="space-between" alignItems="center" mb={3}>
                  <MDTypography variant="h5" fontWeight="bold">🛰️ Live Matrix ({data?.length} locations)</MDTypography>
                  <Paper sx={{ p: "2px 4px", display: "flex", alignItems: "center", width: 300, borderRadius: 2, border: "1px solid #eee", boxShadow: "none" }}>
                      <Icon sx={{ ml: 1, color: "gray" }}>search</Icon>
                      <InputBase
                        sx={{ ml: 1, flex: 1, fontSize: 14 }}
                        placeholder="Search lot ..."
                        onChange={(e) => setSearch(e.target.value)}
                        value={search}
                      />
                  </Paper>
              </Stack>
  
              <Grid container spacing={3}>
                {
                data && data?.length > 0 && data.filter((lot) => lot.lotName.toLowerCase().includes(search.toLowerCase()) || lot.parkingCode.toLowerCase().includes(search.toLowerCase())).map((lot, i) => (
                  <Grid item xs={12} md={6} key={i}>
                    <Card sx={{ p: 3, borderRadius: 4, border: "1px solid #f0f0f0" }}>
                      <Stack spacing={2}>
                        <Stack direction="row" justifyContent="space-between" alignItems="center">
                          <Box>
                              <MDTypography variant="h6" fontWeight="bold">{lot?.parkingCode}</MDTypography>
                              <MDTypography variant="caption" color="text">{lot?.lotName}</MDTypography>
                          </Box>
                          <Stack direction="row" alignItems="center" spacing={1}>
                              <Box sx={{ width: 10, height: 10, borderRadius: "50%", bgcolor: lot.color }} />
                              <MDTypography variant="caption" fontWeight="bold" sx={{ color: lot.color }}>{lot.status}</MDTypography>
                          </Stack>
                        </Stack>
  
                        <Stack direction="row" justifyContent="space-between" alignItems="flex-end">
                          <Box>
                              <MDTypography variant="h4">🚗 {lot.freeSpaces}</MDTypography>
                              <MDTypography variant="caption" color="text" fontWeight="bold">FREE SPACES</MDTypography>
                          </Box>
                          <MDTypography variant="caption" color="text" fontWeight="bold">{lot.reserved} / {lot.totalSpaces} <br/> RESERVED</MDTypography>
                        </Stack>

                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Box sx={{ width: '100%' }}>
                        <MDProgress
                          variant="determinate"
                          value={(lot.reserved / lot.totalSpaces) * 100}
                          sx={{ height: 10, borderRadius: 5, bgcolor: "#eee", "& .MuiLinearProgress-bar": { bgcolor: lot.color },overflow:"hidden" }}
                        />
                        <Box sx={{ minWidth: 35 }}>
                              <MDTypography
                                variant="body2"
                                sx={{ color: 'text.secondary' }}
                              >{`${Math.round((lot.reserved / lot.totalSpaces) * 100)}%`}</MDTypography>
                            </Box>
                            </Box>
                        </Box>
                        <Stack direction="row" spacing={1}>
                          <Chip icon={<Icon sx={{ fontSize: "14px !important" }}>bolt</Icon>} label="EV READY" size="small" sx={{ borderRadius: 1, bgcolor: "#fffbeb", fontSize: 10, fontWeight: "bold" }} />
                          <Chip icon={<Icon sx={{ fontSize: "14px !important" }}>shield</Icon>} label="SECURE" size="small" sx={{ borderRadius: 1, bgcolor: "#f8fafc", fontSize: 10, fontWeight: "bold" }} />
                        </Stack>
                      </Stack>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </Grid>
  
            {/* ===== RIGHT: ANALYTICS + ALERTS ===== */}
            <Grid item xs={12} md={4}sx={{ order: { xs: 1, md: 2 } }}>
              <MDTypography variant="h5" fontWeight="bold" mb={3}>📊 Visual Analytics</MDTypography>
              <Card sx={{ p: 3, borderRadius: 4 }}>
                {
                top5 && top5.length > 0 && top5.map((lot, i) => (
             <Box key={i} mb={2.5}>
             <Stack direction="row" justifyContent="space-between" alignItems="center" mb={0.5} >
             <MDTypography variant="caption" fontWeight="bold" color="text">{lot.lotName}</MDTypography>
             <MDTypography variant="caption" fontWeight="bold"> 
              {`${Math.round((lot.reserved / lot.totalSpaces) * 100)}%`}
              </MDTypography>
             </Stack>
            <MDProgress variant="determinate" value={(lot.reserved / lot.totalSpaces) * 100}
            sx={{ height: 12, borderRadius: 5, mt: 0.5, bgcolor: "#f0f0f0", "& .MuiLinearProgress-bar": { bgcolor: lot.color },overflow:"hidden" }}
            />        
             </Box>
            ))}
              </Card>
  
              {/* <MDTypography variant="h5" fontWeight="bold" mt={4} mb={2}>⚠️ System Alerts</MDTypography>
              <Stack spacing={2}>
                  <Card sx={{ p: 3, borderRadius: 4, bgcolor: "#fff7ed", border: "1px solid #ffedd5" }}>
                    <Stack direction="row" spacing={2} alignItems="center" mb={1}>
                      <Icon sx={{ color: "#f97316" }}>local_fire_department</Icon>
                      <MDTypography variant="button" fontWeight="bold" sx={{ color: "#9a3412" }}>PEAK LOAD</MDTypography>
                    </Stack>
                    <MDTypography variant="caption" color="text" sx={{ lineHeight: 1.5 }}>
                      Downtown Garage is nearing saturation. Redirecting new incoming signals to underutilized lots.
                    </MDTypography>
                  </Card>
              </Stack> */}
            </Grid>
          </Grid>
        </MDBox>
        <Footer />
      </DashboardLayout>
    );
  }